
import React, { Component, useEffect, useState } from "react"
import styled, { css } from "styled-components"
import { media } from "utils/Media"
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, UncontrolledTooltip } from "reactstrap"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faAngleDown } from "@fortawesome/free-solid-svg-icons"
import FilterDropdown from "components/shared/FilterDropdown"
import WPLink from "components/shared/WPLink"
import classNames from "classnames"
import { GatsbyImage } from "gatsby-plugin-image"

const TicketBlock = styled.div`
	background: ${props => props.theme.colors.white};
	color: ${props => props.theme.colors.black};
	text-align: center;
	position: relative;
	z-index: 10;
	height: 100%;

	${props => props.dropdownActive && css`
		z-index: 11;
	`}

	&:before {
		content: "";
		position: absolute;
		display: none;
		width: 100%;
		height: 100%;
		background-color: black;
		left: .5rem;
		top: .5rem;
		z-index: 1;
	}

	h4 {
		margin: 0;
		font-family: ${props => props.theme.font.family.heading};
		font-size: ${props => props.theme.font.size.md};
		//font-style: italic;
		color: ${props => props.theme.colors.black};
		text-transform: uppercase;
		@media ${media.md} {
			font-size: ${props => props.theme.font.size.lg};
		}

		@media (min-width: 1400px) {
			font-size: ${props => props.theme.font.size.xl};
		}
	}
	
	p.description {
		font-size: ${props => props.theme.font.size.base};
		line-height: 1.5;
		margin: 21px 0;
		font-family: ${props => props.theme.font.family.base};
	}
	
	.subtitle {
		font-family: ${props => props.theme.font.family.base};
		font-size: ${props => props.theme.font.size.md};
		font-weight: 700;
		color: ${props => props.theme.colors.black};
		margin: 0 0 .5rem 0;
	}
	.ticket-links-wrapper {
		display: none;
			flex-direction: column;
			/* gap: 1rem;
			.links2 {
				margin-bottom: 1rem;
			} */

			&.active {
				display: flex;
			}
		}
	.price {
		margin: 2rem auto;
		display: none;
		text-align: center;
		justify-content: space-between;

		&.active {
			display: flex;
			justify-content: center;
			flex-wrap: nowrap;
		}

		.price-wrap {
			padding: 0 1rem;
		}
		

		.price-text {
			font-size: 2.5rem;
			font-family: ${props => props.theme.font.family.black};
			line-height: 1; 

			&.price--small {
				font-size: 1.5rem;
				line-height: 3;
			}   
		}
	}
	

	.package-details {
		width: 100%;
		margin: 14px 0 0;
		background-color: ${props => props.theme.colors.tertiary};
		text-align: left;
		padding: 1rem;
		text-align: center;

	    @media ${media.md} {
  			position: relative;
	    }  

		.title {
			color: ${props => props.theme.colors.white};
			font-size: ${props => props.theme.font.size.base};
			font-family: ${props => props.theme.font.family.black};
		}

		ul {
			padding: 0;
			margin: 0;
			text-align: left;
			list-style: none;

			li {
				padding: .25rem 0;
				position: relative;
				padding-left: 20px;

				&:before {
					content: "";
					position: absolute;
					height: 9px;
					width: 9px;
					left: 0;
					top: .85rem;
					background-color: ${props => props.theme.colors.white};
				}

				.ticket-tooltip {
					margin-left: .5rem;
					color: ${props => props.theme.colors.primary};
					cursor: pointer;
					display: inline-block;
				}

				.text {
					display: inline-block;
					p {
					    font-size: 0.875rem;/*14*/
					    line-height: 1.5;
					    color:  ${props => props.theme.colors.white};
						
					    i,em {
					    	font-family: ${props => props.theme.font.family.italic};
					    }
					    strong,b {
					    	font-family: ${props => props.theme.font.family.bold};
					    }
					  	a {
					  		text-decoration: underline;
					  	}
					}
				}
			}
		}
  }
`

const TicketInner = styled.div`
	position: relative;
	z-index: 2;
	background-color: white;
	padding: 2rem 1rem;
	height: 100%;

	@media ${media.md} {
		padding: 4rem 1rem;
	}

	@media ${media.lg} {
		padding: 2rem;
	}

	@media ${media.xl} {
		padding: 2rem 1rem;
	}

	${props => props.highlight && css`
		/* border: 8px solid ${props => props.theme.colors.secondary}; */

		&:before,
		&:after {
			content: "${props.highlight}";
			position: absolute;
			bottom: calc(100% +  4px);
			background-color: ${props => props.theme.colors.secondary};
			font-size: ${props => props.theme.font.size.sm};
			font-family: ${props => props.theme.font.family.bold};
			padding: .25rem .5rem;
			left: 1rem;
			display: none;
		}

		&:after {
			top: calc(100% +  4px);
			bottom: auto;
			right: 1rem;
			left: auto;
		}
	`}
`

const UncontrolledTooltipStyled = styled(UncontrolledTooltip)`
	.tooltip .tooltip-inner {
		p {
			font-size: 0.8rem !important;
		}
		a {
			color: white !important;
		}
	}
`

const StyledBookTickets = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 10px;
	margin-bottom: 1rem;
	/* display: grid;
	grid-template-columns:  1fr 60%;
	grid-gap: 1rem; */
	a {
		max-width: 165px;
		margin: 0 auto;
	}
	.gatsby-image-wrapper {
		width: 100%;
		img {
			object-fit: contain!important ;
		}
	}
	@media ${media.xl} {
		flex-direction: row;
		/* a {
			width: 50%;
			padding: 10px 5px;
		} */
	}
`

const Ticket = (props) => {	
	console.log(props)
	const [activePrice, setActivePrice] = useState(-1)
	const [dropdownActive, setDropdownActive] = useState(false)
	const [priceTitle, setPriceTitle] = useState("Choose date")
	const [priceLink, setPriceLink] = useState(false)
	const [ticketLinks, setTicketLinks] = useState(null)

	useEffect(() =>{
		const infoIcons = document.getElementsByClassName("ticket-tooltip")

		for (let infoIcon of infoIcons) {
			const sibling = infoIcon.previousElementSibling
			if (sibling) {
				sibling.appendChild(infoIcon)
			}
		}
	}, [])

	const togglePrice = (price, title, link, ticketLinks) => {
		setActivePrice(price)
		setPriceTitle(title)
		setPriceLink(link)
		setTicketLinks(ticketLinks)
	}
	useEffect(() => {
		console.log(ticketLinks)
	}, [ticketLinks, setTicketLinks])

	const dropdownToggle = () => {
		setDropdownActive(!dropdownActive)
	}

	const trackTicketClick = (ticketName, buttonText, buttonLink) => {
		window.analytics.track("Tickets button click", {
			ticketName: ticketName,
			buttonText: buttonText,
			buttonLink: buttonLink
		})
	}

	const data = props.data

	return (
		<TicketBlock dropdownActive={dropdownActive}>
			<TicketInner highlight={data.acfTickets.highlight}>
				<h4 dangerouslySetInnerHTML={{ __html: data.title }} />
				{data.acfTickets.description &&
					<p className="description" dangerouslySetInnerHTML={{ __html: data.acfTickets.description }} />
				}
				
				{data.acfTickets.prices &&
					<>
						<FilterDropdown isOpen={dropdownActive} toggle={dropdownToggle} as={Dropdown} tickets>
							<DropdownToggle caret>
								{priceTitle}
								<FontAwesomeIcon icon={faAngleDown} style={{ maxWidth: "20px" }} />
							</DropdownToggle>
							
							<DropdownMenu flip={false}>
								{data.acfTickets.prices && data.acfTickets.prices.map((price, i) => {
									return (
										<DropdownItem key={i} onClick={() => togglePrice(i, price.session, price.link, price.ticketLinks)}>
											{price.session}
										</DropdownItem>
									)
								})}
							</DropdownMenu>
						</FilterDropdown>

						{data.acfTickets.prices.map((price, i) => (
							<>
							<div 
								key={i}
								className={classNames({
									price: true,
									active: activePrice === i
								})}
							>
								{price.price &&
									<div className="price-wrap">
										{price.priceTitle &&
											<p className="subtitle" dangerouslySetInnerHTML={{ __html: price.priceTitle  }} />
										}
										{price.price === "SOLD OUT" ? (
											<p className="price-text price--small" dangerouslySetInnerHTML={{ __html: price.price }} />
										) : (
											<p className="price-text" dangerouslySetInnerHTML={{ __html: price.price }} />
										)}
									</div>
								}
								{price.price2 &&
									<div className="price-wrap">
										{price.priceTitle2 &&
											<p className="subtitle" dangerouslySetInnerHTML={{ __html: price.priceTitle2  }} />
										}
										{price.price2 === "SOLD OUT" ? (
											<p className="price-text price--small" dangerouslySetInnerHTML={{ __html: price.price2 }} />
										) : (
											<p className="price-text" dangerouslySetInnerHTML={{ __html: price.price2 }} />
										)}
									</div>
								}
							</div>

							{ticketLinks && (
								<>
								{price.ticketLinks && (
									<div className={classNames({
										"ticket-links-wrapper": true,
											active: activePrice === i
										})}
									>
										{price.ticketLinks.map((links, i) => {
											return (
												<StyledBookTickets className={`links${i}`} key={i}>
												{links.logo && (
														<GatsbyImage 
														image={links.logo.localFile.childImageSharp.gatsbyImageData} 
														alt={links.logo.altText} 
														width={150}
													/>
												)}
												{links.link && (
													<WPLink 
													url={links.link.url} 
													target={links.link.target} 
													button 
													color="alt" 
												>
													{links.link.title}
												</WPLink>
												)}
												</StyledBookTickets>
											)
										})}
									</div>
								)}
								</>
							)}
				
							{/* {price.ticketLinks && (
							<div>
							</div>

							)} */}
							</>
						))}
						{priceLink && priceLink.url &&
							<div className="booking-links">
								<WPLink 
									url={priceLink.url} 
									target={priceLink.target} 
									button 
									color="alt" 
									onClick={() => trackTicketClick(priceTitle, priceLink.title, priceLink.url)}
								>
									{priceLink.title}
								</WPLink>
							</div>
						}
					</>
				} 

				{props.displayIncludes === "yes" && data.acfTickets.accordion && data.acfTickets.accordion.length>0 &&
					<div className='package-details'>
						<p className="title m-0">{data.acfTickets.packageDetailsTitle}</p>
						<ul>
							{data.acfTickets.accordion.map((item, i) => {
								const id = `${props.id}tooltip${i}`
								const text = item.tooltip 
								? `${item.text}<span id="${id}" class="ticket-tooltip"><span class="sr-only">More information</span>${infoSvg}</span>` 
								: item.text
								return(
									<li key={i}>
										<div className="text" dangerouslySetInnerHTML={{ __html: text }} />
										{item.tooltip && 
											<UncontrolledTooltipStyled placement="top" target={id} autohide={false}>
												<span dangerouslySetInnerHTML={{ __html: item.tooltip }} />
											</UncontrolledTooltipStyled>
										}
									</li>
								)
							})}
						</ul>
					</div>
				}
			</TicketInner>			            	              
		</TicketBlock>
	)
}

export default Ticket

const infoSvg = `<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="info-circle" class="svg-inline--fa fa-info-circle fa-w-16 " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"></path></svg>`